import { ReactNode } from 'react';
import type { CallEvent } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records-ext/call-path/v1/api.pb';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { getEventBody } from './get-event-accordion-body';

interface AccordionEventProps<T extends CallEvent = CallEvent> {
  event: T;
  eventKey: string;
  callerName?: string;
  children: ReactNode;
}

export const AccordionEvent = <T extends CallEvent>({
  event,
  eventKey,
  callerName,
  children,
}: AccordionEventProps<T>) => {
  const renderChild = getEventBody(event, callerName);

  return (
    <Accordion
      distance={0}
      key={eventKey}
      className='event-box-item call-path-mapping-accordion'
      css={{ position: 'relative' }}
      padding={0}
      startingValue={eventKey}
    >
      <Accordion.Item value={eventKey}>
        <Accordion.Header>{children}</Accordion.Header>
        <Accordion.Body css={{ backgroundColor: theme.colors.white }}>{renderChild}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
